import { IProductOption } from "@faire/web-api/indigofair/data/IProductOption";
import { IProductPageResponse } from "@faire/web-api/indigofair/data/IProductPageResponse";
import { Row } from "@faire/web/slate/Layout";
import React from "react";
import styled from "styled-components";

import { ProductOptionPOSInventory } from "@faire/retailer/features/PointOfSale/components/PDPInventory/ProductOptionPOSInventory";
import { ProductAddToCartStateHooks } from "@faire/retailer/views/product/ProductDetails/AddToCart/useProductAddToCartState";

import { ProductAddToCartState } from "../AddToCart/ProductAddToCartState";

import { SKUsText } from "./SKUsText";

export const VariantLevelInfo: React.FunctionComponent<
  VariantLevelInfo.IProps
> = ({
  product,
  selectedOption,
  productAddToCartState,
  actionWhenSKUVisible,
}) => {
  return (
    <Wrapper>
      <SKUsText
        product={product}
        selectedOption={selectedOption}
        productAddToCartState={productAddToCartState}
        actionWhenVisible={actionWhenSKUVisible}
      />
      {productAddToCartState.isOpenSizingVariant ? null : (
        <ProductOptionPOSInventory optionToken={selectedOption?.token ?? ""} />
      )}
    </Wrapper>
  );
};

namespace VariantLevelInfo {
  export interface IProps {
    product: IProductPageResponse.IPdpProduct;
    selectedOption?: IProductOption;
    productAddToCartState: ProductAddToCartState | ProductAddToCartStateHooks;
    actionWhenSKUVisible: () => void;
  }
}

const Wrapper = styled(Row).attrs({ gap: "3x", align: "center" })`
  margin-bottom: 24px;
  &:empty {
    margin-bottom: 0px;
  }
`;
